import React, { Component } from 'react';
import moment from 'moment';
import ReactDataGrid from 'react-data-grid';
import { Data } from 'react-data-grid-addons';
import { Field } from 'redux-form';
import { Grid, Row, Col, Panel, Button, ButtonToolbar, Breadcrumb, Dropdown, MenuItem } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';

import ContentWrapper from '../../components/Layout/ContentWrapper';
import { UI_HEIGHT } from '../Common/constants';
import Spinner from '../../components/Widgets/spinner';
import { DisabledInputField } from '../Common/inputField';
import { toFromDates } from '../Common/cleanDates';
import { numberWithCommas } from '../Common/numberWithCommas';
import CashFormatter from '../Common/cashFormatter';
import genericRadioFilter from '../Common/genericRadioFilter';
import GenericSelection from '../Common/GenericSelection';
import GenericDatePicker from '../Common/GenericDatePicker';

import { ROOT_URL, ROOT_API_URL, companyCodeTitle } from '../../actions/root_url';

const isAFG = ROOT_API_URL === 'https://afg-scm.truckxi.com/api/' || ROOT_URL === 'https://afgstage-scm.truckxi.com/api/';

const getBsStyle = (input, value) => {
  return input === value ? 'success' : 'primary';
};

class GeneralReport extends Component {
  static getQuarter() {
    return Math.ceil((new Date().getMonth() + 1) / 3);
  }
  constructor() {
    super();
    this.state = {
      tableHeight: window.innerHeight - UI_HEIGHT.twoLineButton,
      reportLines: {
        rows: [],
        filters: {},
        sortColumn: null,
        sortDirection: null,
      },
      // GrandPurchase : 0,
      GrandSale: 0,
      GrandAR: 0,
      GrandAP: 0,
      GrandTax: 0,
      GrandVoid: 0,
      fromDate: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000),
      toDate: new Date(),
      SalesType: 'all',
      typeRadios: 'month',
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1,
      quarter: GeneralReport.getQuarter(),
      state: '',
    };
    this.handleResize = this.handleResize.bind(this);
    this.fetchGeneralReport = this.fetchGeneralReport.bind(this);
    this.formatFetchRange = this.formatFetchRange.bind(this);
    this.formatFetchYear = this.formatFetchYear.bind(this);
    this.formatFetchMonth = this.formatFetchMonth.bind(this);
    this.formatFetchQuarter = this.formatFetchQuarter.bind(this);
    this.formatFetchState = this.formatFetchState.bind(this);
    this.handleStatusFilterChange = this.handleStatusFilterChange.bind(this);
    this.handleDateFilterChange = this.handleDateFilterChange.bind(this);
    this.setToDate = this.setToDate.bind(this);
    this.setFromDate = this.setFromDate.bind(this);
    this.setYearSelected = this.setYearSelected.bind(this);
    this.setMonthSelected = this.setMonthSelected.bind(this);
    this.setStateSelected = this.setStateSelected.bind(this);
    this.setQuarterSelected = this.setQuarterSelected.bind(this);
  }

  componentWillMount() {
    // this.formatFetchMonth();
  }

  componentDidMount() {
    document.title = companyCodeTitle;
    window.addEventListener('resize', this.handleResize);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.generalReport && nextProps.generalReport !== this.props.generalReport) {
      const reportLines = { ...this.state.reportLines, rows: nextProps.generalReport.reportLines };
      const {
        GrandPurchase, GrandSale, GrandAR, GrandAP, GrandTax, GrandVoid,
      } = nextProps.generalReport;
      this.setState({
        reportLines, GrandPurchase, GrandSale, GrandAR, GrandAP, GrandTax, GrandVoid,
      });
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  setToDate(e) {
    if (e < this.state.fromDate) {
      return;
    }
    this.setState({ toDate: e });
  }
  setFromDate(e) {
    if (e > this.state.toDate) {
      return;
    }
    this.setState({ fromDate: e });
  }

  setYearSelected(e) {
    // this.setState({ year: e.value }, this.formatFetchYear);
    this.setState({ year: e.value });
  }

  setMonthSelected(e) {
    // this.setState({ month: e.value }, this.formatFetchMonth);
    this.setState({ month: e.value });
  }

  setStateSelected(e) {
    // this.setState({ state: e.value }, this.formatFetchState);
    this.setState({ state: e.value });
  }

  setQuarterSelected(e) {
    // this.setState({ quarter: e.value }, this.formatFetchQuarter);
    this.setState({ quarter: e.value });
  }

  getYearOptions() {
    const yearOptions = [];
    let year = (new Date().getFullYear() + 1);
    while (year > 2017) {
      year -= 1;
      yearOptions.push({ value: year, label: year });
    }
    return yearOptions;
  }

  getMonthOptions() {
    const { year } = this.state;
    const dateMap = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const monthOptions = [];
    const currentyear = new Date().getFullYear();
    let month = 0;
    if (year) {
      if (year < currentyear) {
        month = 12;
      } else {
        month = new Date().getMonth() + 1;
      }
      for (let i = 1; i < month + 1; i += 1) {
        monthOptions.push({ value: i, label: dateMap[i - 1] });
      }
    }
    return monthOptions;
  }

  getQuarterOptions() {
    const { year } = this.state;
    const quarterOptions = [];
    const currentyear = new Date().getFullYear();
    let quarter = 0;
    if (year) {
      if (year < currentyear) {
        quarter = 4;
      } else {
        const month = new Date().getMonth() + 1;
        quarter = (Math.ceil(month / 3));
      }
    }
    for (let i = 1; i < quarter + 1; i += 1) {
      quarterOptions.push({ value: i, label: i });
    }
    return quarterOptions;
  }

  handleResize(e) {
    this.setState({ tableHeight: window.innerHeight - UI_HEIGHT.twoLineButton });
  }

  formatFetchRange() {
    const { SalesType, typeRadios, fromDate, toDate, state } = this.state;
    this.setState({
      fromDate, toDate, SalesType, typeRadios, state,
    }, this.fetchGeneralReport);
  }

  formatFetchYear() {
    const { SalesType, typeRadios, year, state } = this.state;
    const FromDate = `${year}-01-01`;
    const ToDate = `${year}-12-31`;
    const dates = toFromDates(-1, FromDate, ToDate);
    this.setState({
      fromDate: dates.fromDate, toDate: dates.toDate, SalesType, typeRadios, state,
    }, this.fetchGeneralReport);
  }

  formatFetchMonth() {
    const {
      year, month, SalesType, typeRadios, state,
    } = this.state;
    let FromDate = moment([year, month - 1]);
    let ToDate = moment(FromDate).endOf('month');
    FromDate = FromDate.toISOString();
    ToDate = ToDate.toISOString();
    this.setState({
      fromDate: FromDate, toDate: ToDate, SalesType, typeRadios, state,
    }, this.fetchGeneralReport);
  }

  formatFetchQuarter() {
    const {
      year, quarter, SalesType, typeRadios, state,
    } = this.state;
    let FromDate = moment([year, (quarter - 1) * 3]);
    let ToDate = moment([year, (quarter * 3) - 1]).endOf('month');
    FromDate = FromDate.toISOString();
    ToDate = ToDate.toISOString();
    this.setState({
      fromDate: FromDate, toDate: ToDate, SalesType, typeRadios, state,
    }, this.fetchGeneralReport);
  }

  formatFetchState() {
    const {
      year, month, quarter, SalesType, typeRadios, state,
    } = this.state;
    this.setState({
      SalesType, typeRadios, state,
    }, this.fetchGeneralReport);
  }

  formatDate(date) {
    let formattedDate = ''
    if ((date.getMonth()+1) < 10) {
      formattedDate = '0' + (date.getMonth()+1) + '/';
    } else {
      formattedDate = date.getMonth()+1 + '/';
    }
    if (date.getDate() < 10) {
      formattedDate += '0' + date.getDate()+ '/';
    } else {
      formattedDate += date.getDate()+ '/';
    }
    formattedDate += date.getFullYear();
    return formattedDate;
  }

  getFormattedDate = () => {
    const {
      year, month, SalesType, typeRadios, state, quarter, fromDate, toDate,
    } = this.state;
    if (typeRadios === 'year') {
      const FromDate = `${year}-01-01`;
      const ToDate = `${year}-12-31`;
      const dates = toFromDates(-1, FromDate, ToDate);
      return {
        fromDate: dates.fromDate, toDate: dates.toDate,
      };
    }

    if (typeRadios === 'quarter') {
      let fromDate2 = moment([year, (quarter - 1) * 3]);
      let toDate2 = moment([year, (quarter * 3) - 1]).endOf('month');
      fromDate2 = fromDate2.toISOString();
      toDate2 = toDate2.toISOString();
      return {
        fromDate: fromDate2, toDate: toDate2,
      };
    }

    if (typeRadios === 'month') {
      let fromDate2 = moment([year, month - 1]);
      let toDate2 = moment(fromDate2).endOf('month');
      fromDate2 = fromDate2.toISOString();
      toDate2 = toDate2.toISOString();
      return {
        fromDate: fromDate2, toDate: toDate2,
      };
    }

    if (typeRadios === 'range') {
      let fromDate2 = fromDate.toISOString();
      let toDate2 = toDate.toISOString();
      return {
        fromDate: fromDate2,
        toDate: toDate2,
      };
    }
  }

  fetchGeneralReport() {
    const { typeRadios } = this.state;
    let typeRadios2 = '';
    if (typeRadios === 'range') {
      typeRadios2 = 'month';
    } else {
      typeRadios2 = typeRadios;
    }
    this.props.fetchGeneralReport('show', this.state.SalesType, typeRadios2, this.state.fromDate, this.state.toDate, this.state.state);
  }

  handleStatusFilterChange(status) {
    // old version fetch reports on filter buttons click
    // const { typeRadios } = this.state;
    // if (typeRadios === 'year') {
    //   this.setState({ SalesType: status }, this.formatFetchYear);
    // } else if (typeRadios === 'month') {
    //   this.setState({ SalesType: status }, this.formatFetchMonth);
    // } else {
    //   this.setState({ SalesType: status }, this.formatFetchQuarter);
    // }

    // preserve the filters and fetch reports with preserved filter when search button is clicked
    this.setState({ SalesType: status })
  }

  handleDateFilterChange(type) {
    // old version fetch reports on filter buttons click
    // if (type === 'year') {
    //   this.setState({ typeRadios: type, year: new Date().getFullYear() }, this.formatFetchYear);
    // } else if (type === 'month') {
    //   this.setState({ typeRadios: type, year: new Date().getFullYear(), month: new Date().getMonth() + 1 }, this.formatFetchMonth);
    // } else {
    //   this.setState({ typeRadios: type, year: new Date().getFullYear(), quarter: GeneralReport.getQuarter() }, this.formatFetchQuarter);
    // }

    const {
      fromDate, toDate,
    } = this.state;

    if (type === 'year') {
      this.setState({ typeRadios: type, year: new Date().getFullYear() });
    } else if (type === 'month') {
      this.setState({ typeRadios: type, year: new Date().getFullYear(), month: new Date().getMonth() + 1 });
    } else if (type === 'range') {
      this.setState({ typeRadios: type, fromDate, toDate});
    } else {
      this.setState({ typeRadios: type, year: new Date().getFullYear(), quarter: GeneralReport.getQuarter() });
    }
  }

  handleSearchButtonClick = () => {
    const {
      typeRadios,
    } = this.state;
    if (typeRadios === "month") {
      this.formatFetchMonth();
      return;
    }
    if (typeRadios === "quarter") {
      this.formatFetchQuarter();
      return;
    }
    if (typeRadios === "year") {
      this.formatFetchYear();
      return;
    }
    if (typeRadios === "range") {
      this.formatFetchRange();
      return;
    }
  }
  renderDateSelector() {
    const yearOptions = this.getYearOptions();
    const date = new Date();
    const stateOptions = [
      {value: '', label: 'All'},
      {value: 'ca', label: 'CA'},
      {value: 'others', label: 'Others'},
    ];


    if (this.state.typeRadios === 'range') {
      return (
        <Col xs={12}>
          <Col xs={6}>
            <div className="report-table-filters" id="general-report-date-selector">
              <label className="from-label">
                <Translate value="from" />
              </label>
              {
                GenericDatePicker({
                  setDate: this.setFromDate,
                  selectedDate: this.state.fromDate,
                  onChange: (e) => {
                    this.setFromDate(e);
                  },
                })
              }
              <label className="to-label">
                <Translate value="to" />
              </label>
              {
                GenericDatePicker({
                  setDate: this.setToDate,
                  selectedDate: this.state.toDate,
                  onChange: (e) => {
                    this.setToDate(e);
                  },
                })
              }
            </div>
          </Col>
          <Col xs={4}>
            <Button
              bsStyle="primary"
              onClick={() => {
                this.handleSearchButtonClick();
              }}
            >
              <Translate value="search" />
            </Button>
          </Col>
        </Col>
      );
    } else if (this.state.typeRadios === 'month') {
      const monthOptions = this.getMonthOptions();
      return (
        <Col xs={12}>
          <Col xs={6}>
            <div className="report-table-filters" id="general-report-date-selector">
              {
                GenericSelection({
                  translation: <Translate value="year" />,
                  options: yearOptions,
                  value: this.state.year,
                  setSelected: (e) => { this.setState({ year: e.value }); },
                })
              }
              {
                GenericSelection({
                  translation: <Translate value="month" />,
                  options: monthOptions,
                  value: this.state.month,
                  setSelected: this.setMonthSelected,
                })
              }
              {
                isAFG &&
                GenericSelection({
                  translation: <Translate value="state" />,
                  options: stateOptions,
                  value: this.state.state,
                  setSelected: this.setStateSelected,
                })
              }
            </div>
          </Col>
          <Col xs={4}>
            <Button
              // className="search-button"
              bsStyle="primary"
              onClick={() => {
                this.handleSearchButtonClick();
              }}
            >
              <Translate value="search" />
            </Button>
          </Col>
          <Col xs={1}>
            <h3 className="filter-title"><Translate value={this.formatDate(date)} /></h3>
          </Col>
        </Col>
      );
    } else if (this.state.typeRadios === 'quarter') {
      const quarterOptions = this.getQuarterOptions();
      return (
        <Col xs={12}>
          <Col xs={6}>
            <div className="report-table-filters" id="general-report-date-selector">
              {
                GenericSelection({
                  translation: <Translate value="year" />,
                  options: yearOptions,
                  value: this.state.year,
                  setSelected: (e) => { this.setState({ year: e.value }); },
                })
              }
              {
                GenericSelection({
                  translation: <Translate value="quarter" />,
                  options: quarterOptions,
                  value: this.state.quarter,
                  setSelected: this.setQuarterSelected,
                })
              }
              {
                isAFG &&
                GenericSelection({
                  translation: <Translate value="state" />,
                  options: stateOptions,
                  value: this.state.state,
                  setSelected: this.setStateSelected,
                })
              }
            </div>
          </Col>
          <Col xs={4}>
            <Button bsStyle="primary"
              onClick={() => {
                this.handleSearchButtonClick();
              }}
            >
              <Translate value="search" />
            </Button>
          </Col>
          <Col xs={1}>
            <h3 className="filter-title"><Translate value={this.formatDate(date)} /></h3>
          </Col>
        </Col>
      );
    }
    return (
      <Col xs={12}>
        <Col xs={6}>
          <div className="report-table-filters" id="general-report-date-selector">
            {
              GenericSelection({
                translation: <Translate value="year" />,
                options: yearOptions,
                value: this.state.year,
                setSelected: this.setYearSelected,
              })
            }
            {
                isAFG &&
                GenericSelection({
                  translation: <Translate value="state" />,
                  options: stateOptions,
                  value: this.state.state,
                  setSelected: this.setStateSelected,
                })
              }
          </div>
        </Col>
        <Col xs={4}>
          <Button
            bsStyle="primary"
            onClick={() => {
              this.handleSearchButtonClick();
            }}
          >
            <Translate value="search" />
          </Button>
        </Col>
        <Col xs={1}>
          <h3 className="filter-title"><Translate value={this.formatDate(date)} /></h3>
        </Col>
      </Col>
    );
  }

  renderTable() {
    if (this.props.generalReportIsLoading && !this.props.generalReportError) {
      return (
        <div id="spinner">
          <Spinner />
        </div>
      );
    } else if (this.props.generalReportError) {
      return (
        <ContentWrapper>
          <div className="alert alert-danger">{JSON.stringify(this.props.generalReportError)}</div>
        </ContentWrapper>
      );
    } else {
        // Parameters of the react-data-grid

        let tableHeight = (window.innerHeight < 930) ? 470 : 470;

        const getRows = () => {
            return Data.Selectors.getRows(this.state.reportLines);
        }

        const getSize = () => {
            return getRows().length;
        }

        const rowGetter = rowIdx => {
            var rows = getRows();
            return rows[rowIdx];
        }

        // Handle the sortable function

        const handleGridSort = (sortColumn, sortDirection) => {
            var lines = Object.assign({}, this.state.reportLines, { sortColumn: sortColumn, sortDirection: sortDirection });
            this.setState({reportLines:lines});
        }

        //Custom Formatter component

        const DateFormatter = React.createClass({
            render() {
                if (this.props.value) {
                  let dateMap = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
                  let date = new Date(this.props.value)
                  let index = dateMap.indexOf(date.toString().slice(4,3));
                  let localDate = index + date.toString().slice(8, 6);
                  return <span>{date.toString().slice(4, 15)}</span>;;
                }
                else return <span className="label label-danger">-</span>;
            }
        });

        // Formatter for Percentages
        const PercentFormat = React.createClass({
          render() {
            const { value } = this.props;
            return <span>{ (value !== null && !isNaN(value) && `${value}%`) }</span>;
          }
        })

        // Column difinition

        const columns = [
          {
              key: 'month',
              name: <Translate value="M" />,
              resizable: true,
              sortable: true,
              width: 40,
          },
          {
              key: 'day',
              name: <Translate value="D" />,
              resizable: true,
              sortable: true,
              width: 40,
          },
          {
              key: 'total_purchase',
              name: <Translate value="purchase" />,
              resizable: true,
              sortable: true,
              width: 110,
              formatter: CashFormatter,
          },
          {
              key: 'total_sales',
              name: <Translate value="sale" />,
              resizable: true,
              sortable: true,
              width: 110,
              formatter: CashFormatter,
          },
          {
              key: 'total_ar',
              name: <Translate value="A/R"/>,
              resizable: true,
              sortable: true,
              width: 110,
              formatter: CashFormatter,
          },
          {
              key: 'total_ap',
              name: <Translate value="total_ap"/>,
              resizable: true,
              sortable: true,
              width: 110,
              formatter: CashFormatter,
          },
          {
              key: 'total_tax',
              name: <Translate value="tax" />,
              resizable: true,
              sortable: true,
              width: 110,
              formatter: CashFormatter,
          },
          {
              key: 'total_profit',
              name: <Translate value="profit" />,
              resizable: true,
              sortable: true,
              width: 110,
              formatter: CashFormatter,
          },
          {
              key: 'total_margin',
              name: <Translate value="margin" />,
              resizable: true,
              sortable: true,
              width: 80,
              formatter: PercentFormat,
          },
          {
              key: 'total_void',
              name: <Translate value="bounce" />,
              resizable: true,
              sortable: true,
              width: 110,
              formatter: CashFormatter,
          },
        ]

        //React Table Purchase Order Full Table
        return (
          <Row>
            <Col sm={ 12 }>
              <div className="react-table-ar-ap-general-report" id="GeneralReport-dataGrid1">
                <ReactDataGrid
                    enableCellSelect={true}
                    onGridSort={handleGridSort}
                    columns={columns}
                    rowHeight={25}
                    rowGetter={rowGetter}
                    rowsCount={getSize() }
                    minHeight={tableHeight}
                  />
              </div>
            </Col>
          </Row>
        )
    }
  }

  render() {
    const {
      SalesType, typeRadios, state,
    } = this.state;
    const { fromDate, toDate } = this.getFormattedDate();
    let typeRadios2 = typeRadios;
    if (typeRadios === 'range') {
      typeRadios2 = 'month';
    }
    let params = `type=${typeRadios2}&start_date=${fromDate}&end_date=${toDate}`;
    if (isAFG) {
      params = `type=${typeRadios2}&start_date=${fromDate}&end_date=${toDate}&state=${state}`;
    }
    const printUrl = `${ROOT_URL}v1/ar/report/print/${(SalesType || 'all')}/?${params}&Bearer=${localStorage.getItem('token')}`;
    const excelUrl = `${ROOT_URL}v1/ar/report/excel/${(SalesType || 'all')}/?${params}&Bearer=${localStorage.getItem('token')}`;

    return (
      <ContentWrapper>
        <Breadcrumb>
          <Breadcrumb.Item>
            <Translate value="ar_slashsign_ap" />
          </Breadcrumb.Item>
          <Breadcrumb.Item active="true">
            <Translate value="general_report" />
          </Breadcrumb.Item>
        </Breadcrumb>

        <ButtonToolbar>
          <Button bsStyle="primary" href={printUrl} >
            <em className="fa fa-print" /><Translate value="print" />
          </Button>
          <Button bsStyle="success" href={excelUrl} >
            <em className="fa fa-download" /><Translate value="excel" />
          </Button>
        </ButtonToolbar>

        <Grid id="general-report">
          {/* <h1><Translate value="ar_ap_general_report" /></h1> */}
          {/* Date Range Pickers */}
          <Row>
            <Col xs={ 12 }>
              <Panel id="date-range-picker" className="form-horizontal">
                <Row>
                  <Col xs={ 1 }>
                    <h3 className="text-nowrap"><Translate value="order_type" /><span className="colon">:</span></h3>
                  </Col>
                  <Col xs={ 10 }>
                    <div id="statusFilterRadios">
                      {
                        genericRadioFilter({
                          content: [
                            {
                                option: 'all',
                                id: 'all-radio-filter',
                                name: 'statusFilterRadios',
                                labelName: 'all',
                            },
                            {
                                option: 'pos',
                                id: 'pos-radio-filter',
                                name: 'statusFilterRadios',
                                labelName: 'pos',
                            },
                            {
                                option: 'si',
                                id: 'salesOrder-radio-filter',
                                name: 'statusFilterRadios',
                                labelName: 'sales_order',
                            },
                            {
                                option: 'mso',
                                id: 'mobileSalesOrder-radio-filter',
                                name: 'statusFilterRadios',
                                labelName: 'MSO',
                            },
                          ],
                          value: this.state.SalesType,
                          handleOnClick: this.handleStatusFilterChange,
                          type: 'buttons',
                        })
                      }
                    </div>
                  </Col>
                  <Col xs={ 1 }>
                    <h3 className="text-nowrap"><Translate value="time_range" /><span className="colon">:</span></h3>
                  </Col>
                  <Col xs={ 6 }>
                    <div id="statusFilterRadios">
                      {
                        genericRadioFilter({
                          content: [
                            {
                                option: 'year',
                                id: 'year-radio-filter',
                                name: 'dateFilterRadios',
                                labelName: 'year',
                            },
                            {
                                option: 'quarter',
                                id: 'quarter-radio-filter',
                                name: 'dateFilterRadios',
                                labelName: 'quarter',
                            },
                            {
                                option: 'month',
                                id: 'month-radio-filter',
                                name: 'dateFilterRadios',
                                labelName: 'month',
                            },
                            {
                                option: 'range',
                                id: 'dateRange-radio-filter',
                                name: 'dateFilterRadios',
                                labelName: 'date_range',
                            },
                          ],
                          value: this.state.typeRadios,
                          handleOnClick: this.handleDateFilterChange,
                          type: 'buttons',
                        })
                      }
                    </div>
                  </Col>
                  {this.renderDateSelector()}
                </Row>
              </Panel>
              <Row>
                <Col xs={ 12 }>
                  <Panel className="position-relative mb0" id="table-collapse-fix">
                    {/* Render Inventory Table  */}
                    {this.renderTable() }
                  </Panel>
                </Col>
                <Col xs={ 12 }>
                  <Panel className="position-relative table-collapse-fix mb0">
                    <Col xs={ 2 }>
                      <label className="col-xs-6 text-nowrap"><Translate value="total_purchase" /><span className="dollar-sign"> $$</span>:&nbsp;</label>
                      <Col xs={ 6 }>
                        <Field name="GrandPurchase" component={DisabledInputField} placeholder={`${numberWithCommas(this.state.GrandPurchase)}` || 0}/>
                      </Col>
                    </Col>
                    <Col xs={ 2 }>
                      <label className="col-xs-6 text-nowrap"><Translate value="total_sales_invoices" /><span className="dollar-sign"> $$</span>:&nbsp;</label>
                      <Col xs={ 6 }>
                        <Field name="GrandSale" component={DisabledInputField} placeholder={`${numberWithCommas(this.state.GrandSale)}` || 0}/>
                      </Col>
                    </Col>
                    <Col xs={ 2 }>
                      <label className="col-xs-6 text-nowrap"><Translate value="total_AR" /><span className="dollar-sign"> $$</span>:&nbsp;</label>
                      <Col xs={ 6 }>
                        <Field name="GrandAR" component={DisabledInputField} placeholder={`${numberWithCommas(this.state.GrandAR)}` || 0}/>
                      </Col>
                    </Col>
                    <Col xs={ 2 }>
                      <label className="col-xs-6 text-nowrap"><Translate value="total_AP" /><span className="dollar-sign"> $$</span>:&nbsp;</label>
                      <Col xs={ 6 }>
                        <Field name="GrandAP" component={DisabledInputField} placeholder={`${numberWithCommas(this.state.GrandAP)}` || 0}/>
                      </Col>
                    </Col>
                    <Col xs={ 2 }>
                      <label className="col-xs-6 text-nowrap"><Translate value="total_tax" /><span className="dollar-sign"> $$</span>:&nbsp;</label>
                      <Col xs={ 6 }>
                        <Field name="GrandTax" component={DisabledInputField} placeholder={`${numberWithCommas(this.state.GrandTax)}` || 0}/>
                      </Col>
                    </Col>
                    <Col xs={ 2 }>
                      <label className="col-xs-6 text-nowrap"><Translate value="total_bounce" /><span className="dollar-sign"> $$</span>:&nbsp;</label>
                      <Col xs={ 6 }>
                        <Field name="GrandVoid" component={DisabledInputField} placeholder={`${numberWithCommas(this.state.GrandVoid)}` || 0}/>
                      </Col>
                    </Col>
                  </Panel>
                </Col>
              </Row>
            </Col>
          </Row>

        </Grid>
      </ContentWrapper>
      //---------------
      // End HTML: Purchase Order List
      //---------------

    )
  }
}

export default GeneralReport;



// WEBPACK FOOTER //
// ./master/jsx/components/AR/generalReport.jsx